import { MatDateFormats } from '@angular/material/core';


export const PV_DATE_FORMATS: MatDateFormats = {
  parse: {
    // moment.parse() with an array tries each format and keeps the best match — without this, typing
    // anything other than the exact ISO 'YYYY-MM-DD' (e.g. the natural '01/09/2018') silently misparsed
    // into a nonsensical date via moment's non-strict fallback, with no validation error shown (UX finding:
    // "the date filter doesn't line up with the actual dates" traced to this).
    dateInput: ['DD/MM/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'],
  },
  display: {
    dateInput: 'MMM D, YY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};